import * as PIXI from 'pixi.js'
import { ResourceIdentifier } from './ResourceManager/ResourceIdentifier';
import { shuffle } from './MyHelpers';


interface ListItem
{
    pixiApp: PIXI.Application<HTMLCanvasElement>;
    resid: ResourceIdentifier;
}

let registeredPixiApps: ListItem[] = [];

export function RegisterPixi(application: PIXI.Application<HTMLCanvasElement>, resid: ResourceIdentifier)
{
    registeredPixiApps.push({
        pixiApp: application,
        resid: resid
    });
}

export function UnregisterPixi(application: PIXI.Application<HTMLCanvasElement>, resid: ResourceIdentifier)
{
    let index = registeredPixiApps.findIndex(item => item.pixiApp == application)
    if (index == -1)
    {
        throw "Can't find the pixi application instance"
    }

    registeredPixiApps = registeredPixiApps.filter((pixi, i) => i != index);
}

export function SwitchPixiDebug()
{
    console.log(`All pixi apps`, registeredPixiApps);
    const currentIndex = registeredPixiApps.findIndex(li => li.pixiApp == globalThis.__PIXI_APP__);
    console.log(`Current pixi debug app ${currentIndex}`, registeredPixiApps[currentIndex] ?? "not found");

    const nextIndex = (currentIndex + 1) % registeredPixiApps.length;
    console.log(`Next pixi debug app ${nextIndex}`, registeredPixiApps[nextIndex] ?? "not found");

    const app = registeredPixiApps[nextIndex].pixiApp
    globalThis.__PIXI_APP__ = app;
    globalThis.__PIXI_DEVTOOLS__ = {
        app: app
    };

}

export function CrashPixi()
{
    const sortedPixiApps = shuffle([...registeredPixiApps]);
    console.log(`Have ${sortedPixiApps.length} pixi apps`, sortedPixiApps);

    for (let item of registeredPixiApps)
    {
        console.log("Crashing pixi app", item.resid.ID());

        // try webgl2 first
        let webgl2Context = item.pixiApp.view.getContext("webgl2", {});
		if (webgl2Context)
        {
            webgl2Context.getExtension('WEBGL_lose_context')?.loseContext();				
			continue;
		}

        // try webgl2 too
		let webglContext = item.pixiApp.view.getContext("webgl", {});
		if (webglContext != null) {
            webglContext.getExtension('WEBGL_lose_context')?.loseContext();					
			continue;
		}

        // nothing worked
    }
}
